import { Controller } from 'stimulus'

export default class TimeZoneOffsetController extends Controller {
  connect() {
    this.element.value = -new Date().getTimezoneOffset() * 60
  }
}
